import { jsx, jsxs } from "react/jsx-runtime";
import { Slot, Slottable } from "@radix-ui/react-slot";
import { cleanProps, cn } from "../../utils/index.js";
import { CdnIcon } from "../CdnIcon/index.js";
import { aVariants } from "./A.variants.js";
function A({ asChild, children, className, iconLeft, iconRight, ...props }) {
    const { buttonSlot, textSlot, iconSlot } = aVariants(props);
    const classes = cn(buttonSlot(), className);
    const iconSlotClasses = iconSlot();
    const iconSize = 'sm' === props.size ? '20' : '24';
    const Comp = asChild ? Slot : 'a';
    return /*#__PURE__*/ jsxs(Comp, {
        className: classes,
        ...cleanProps(props, [
            'shadow',
            'fullWidth'
        ]),
        children: [
            iconLeft && /*#__PURE__*/ jsx(CdnIcon, {
                className: iconSlotClasses,
                iconName: iconLeft,
                size: iconSize
            }),
            /*#__PURE__*/ jsx(Slottable, {
                children: /*#__PURE__*/ jsx("span", {
                    className: textSlot(),
                    children: children
                })
            }),
            iconRight && /*#__PURE__*/ jsx(CdnIcon, {
                className: iconSlotClasses,
                iconName: iconRight,
                size: iconSize
            })
        ]
    });
}
export { A };
